import { Entity } from '@evidentid/tprm-portal-lib/models/dashboard';
import { ComplianceStatus, VerificationStatus } from '@evidentid/tprm-portal-lib/models/entity-details';

/** The verification states a new request may be created from.
 *
 * Deliberately an explicit list rather than "anything terminal": the terminal set also includes the
 * managed-services outreach states, where Evident staff are mid-conversation with the entity and a
 * client-created link would cut across them.
 */
const ELIGIBLE_VERIFICATION_STATUSES: ReadonlySet<VerificationStatus> = new Set([
    VerificationStatus.complete,
    VerificationStatus.exhausted,
    VerificationStatus.noInsuredResponse,
]);

/** Whether the portal offers "Create a New Link" for this entity.
 *
 * Advisory only — the server gates this for real, because an entity's state can change between the
 * dashboard's last fetch and the click. The job here is to avoid offering an action that will
 * obviously fail, and to keep the count shown to the user consistent with the list actually posted.
 *
 * `paused` is deliberately not consulted: a paused entity gets a working link and no email, which
 * is what pausing means.
 */
export function isEligibleForNewLink(entity: Entity): boolean {
    return entity.active &&
        (entity.complianceStatus === ComplianceStatus.compliant ||
            entity.complianceStatus === ComplianceStatus.nonCompliant) &&
        ELIGIBLE_VERIFICATION_STATUSES.has(entity.verificationStatus);
}
